import Image from 'next/image';
import cn from 'classnames';
import styles from '@/styles/pages/index.module.scss';

const LeftThings = () => {
  return (
    <>
      <div className={cn('absolute bottom-60 -left-10', styles.elegirnosLT1)}>
        <Image src="/images/home/elegirnos/lt1.svg" width={22} height={28} alt="" className="w-auto h-auto" />
      </div>
      <div className={cn('absolute bottom-40 -left-40', styles.elegirnosLT2)}>
        <Image src="/images/home/elegirnos/lt2.svg" width={22} height={20} alt="" className="w-auto h-auto" />
      </div>
    </>
  );
};
export default LeftThings;
